import { replaceTextWithValues } from "./text-replace";

export default (...prices) => {
  const priceRegex = /[0-9.,]+/g;
  const priceFormat = prices[0].replace(priceRegex, "%{total}");

  const isCommaSeparated = prices.some(
    (price) => price && price.toString().includes(",")
  );

  const total = prices
    .map((price) =>
      parseFloat(price.toString().match(priceRegex)[0].replace(",", ".") || "0")
    )
    .reduce((acc, price) => acc + price, 0)
    .toFixed(2);

  let price = replaceTextWithValues(priceFormat, { total });

  if (isCommaSeparated) {
    price = price.replace(".", ",");
  }

  return price;
};
